<template>
  <v-container grid-list-lg fluid>
    <v-layout wrap>
      <v-flex xs12 sm12 md12 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Select Load
          </v-card-title>
          <v-card-text>
            <v-select
              v-model.number='selection'
              :items='storeState.data.loads'
              item-value='id'
              label='Load'
              @visible-change='selection = -1'
            >
              <template slot="selection" slot-scope="data">
                Load {{ data.item.id + 1 }} - {{ data.item.name }}
              </template>
              <template slot="item" slot-scope="data">
                Load {{ data.item.id + 1}} - {{ data.item.name }}
              </template>
            </v-select>
            <template>
              <div>
                <input type="radio" v-model="mode" value="live" id="trends-radio-period-live">&nbsp;<label for="trends-radio-period-live" class="oem-text-color">Live</label>
              </div>
              <div>
                <input type="radio" v-model="mode" value="hourly" id="trends-radio-period-hourly">&nbsp;<label for="trends-radio-period-hourly" class="oem-text-color">Hourly</label>
              </div>
              <div>
                <input type="radio" v-model="mode" value="daily" id="trends-radio-period-daily">&nbsp;<label for="trends-radio-period-daily" class="oem-text-color">Daily</label>
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 class='pa-3' v-show='selection !== -1'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color' v-if='selection !== -1'>
            {{ `${mode === "live" ? "Live" : (mode === "hourly" ? "Hourly" : "Daily")} data for load ${storeState.data.loads[selection].id + 1} - ${storeState.data.loads[selection].name}` }}
          </v-card-title>
          <v-card-text>
            <div v-show='mode !== "live" && loadingTrendData'>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 class='pa-3'>
                  <div style="width:100%;">Loading data...</div>
                </v-flex>
              </v-layout>
            </div>
            <div v-show='mode === "live" || !loadingTrendData'>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 class='pa-3 dense-flex'>
                  <h2>Energy</h2>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode==="live"'>
                  <baseLiveGraph ref='graphTotWhDis' title="Total active energy delivered (imported) from all phases (kWh+)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode==="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotWhDis' title="Total active energy delivered (imported) from all phases hourly (kWh+)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode==="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotWhDis' title="Total active energy delivered (imported) from all phases daily (kWh+)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode==="live"'>
                  <baseLiveGraph ref='graphTotWh' title="Total active energy received (exported) from all phases (kWh-)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode==="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotWh' title="Total active energy received (exported) from all phases hourly (kWh-)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode==="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotWh' title="Total active energy received (exported) from all phases daily (kWh-)" :showLegend="false" yAxisTitle="kWh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotVahDis' title="Total apparent energy delivered (imported) from all phases (kVAh+)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotVahDis' title="Total apparent energy delivered (imported) from all phases hourly (kVAh+)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotVahDis' title="Total apparent energy delivered (imported) from all phases daily (kVAh+)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotVah' title="Total apparent energy received (exported) from all phases (kVAh-)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotVah' title="Total apparent energy received (exported) from all phases hourly (kVAh-)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotVah' title="Total apparent energy received (exported) from all phases daily (kVAh-)" :showLegend="false" yAxisTitle="kVAh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                 <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotIVarh' title="Total reactive energy accumulated in Quadrant 1 from all phases (kvarh_Q1)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotIVarh' title="Total reactive energy accumulated in Quadrant 1 from all phases hourly (kvarh_Q1)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotIVarh' title="Total reactive energy accumulated in Quadrant 1 from all phases daily (kvarh_Q1)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotIVarhDis' title="Total reactive energy accumulated in Quadrant 2 from all phases (kvarh_Q2)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotIVarhDis' title="Total reactive energy accumulated in Quadrant 2 from all phases hourly (kvarh_Q2)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotIVarhDis' title="Total reactive energy accumulated in Quadrant 2 from all phases daily (kvarh_Q2)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotCVarhDis' title="Total reactive energy accumulated in Quadrant 3 from all phases (kvarh_Q3)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotCVarhDis' title="Total reactive energy accumulated in Quadrant 3 from all phases hourly (kvarh_Q3)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotCVarhDis' title="Total reactive energy accumulated in Quadrant 3 from all phases daily (kvarh_Q3)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotCVarh' title="Total reactive energy accumulated in Quadrant 4 from all phases (kvarh_Q4)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotCVarh' title="Total reactive energy accumulated in Quadrant 4 from all phases hourly (kvarh_Q4)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotCVarh' title="Total reactive energy accumulated in Quadrant 4 from all phases daily (kvarh_Q4)" :showLegend="false" yAxisTitle="kvarh" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>

<v-flex xs12 sm12 md12 class='pa-3 dense-flex'>
                  <h2>Power</h2>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotP' title="Total active (real) power from all phases (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotP' title="Total active (real) power from all phases hourly (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotP' title="Total active (real) power from all phases daily (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphA' title="Total current from all phases (A)" :showLegend="false" yAxisTitle="A" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphA' title="Total current from all phases hourly (A)" :showLegend="false" yAxisTitle="A" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphA' title="Amperage over all phases daily (A)" :showLegend="false" yAxisTitle="A" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphV' title="Average line to neutral voltage (V)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <template v-if='line1Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphV' title="Average line to neutral voltage hourly (V)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Max line-to-neutral voltage for the timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Max line-to-neutral voltage for the timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Data is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphV' title="Average line to neutral voltage daily (V)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Max line-to-neutral voltage for the timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Max line-to-neutral voltage for the timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Data is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphVll' title="Average line to line voltage (Vll)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <template v-if='line1Visible && line2Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1 - Line 2</span></div></template>
                    <template v-if='line2Visible && line3Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2 - Line 3</span></div></template>
                    <template v-if='line3Visible && line1Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3 - Line 1</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphVll' title="Average line to line voltage hourly (Vll)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Max line-to-line voltage for the timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Max line-to-line voltage for the timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Data is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphVll' title="Average line to line voltage daily (Vll)" :showLegend="false" yAxisTitle="V" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Max line-to-line voltage for the timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Max line-to-line voltage for the timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Data is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotS' title="Total apparent power from all phases (kVA)" :showLegend="false" yAxisTitle="kVA" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotS' title="Total apparent power from all phases hourly (kVA)" :showLegend="false" yAxisTitle="kVA" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotS' title="Total apparent power from all phases daily (kVA)" :showLegend="false" yAxisTitle="kVA" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotQ' title="Total reactive power from all phases (kvar)" :showLegend="false" yAxisTitle="kvar" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotQ' title="Total reactive power from all phases hourly (kvar)" :showLegend="false" yAxisTitle="kvar" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotQ' title="Total reactive power from all phases daily (kvar)" :showLegend="false" yAxisTitle="kvar" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotApf' title="Average power factor from all phases (aPF)" :showLegend="false" yAxisTitle="aPF" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotApf' title="Average power factor from all phases hourly (aPF)" :showLegend="false" yAxisTitle="aPF" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotApf' title="Average power factor from all phases daily (aPF)" :showLegend="false" yAxisTitle="aPF" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotDpf' title="Average displacement (fundamental frequency) power factor from all phases (dPF)" :showLegend="false" yAxisTitle="dPF" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>

                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotDpf' title="Average displacement (fundamental frequency) power factor from all phases hourly (dPF)" :showLegend="false" yAxisTitle="dPF" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotDpf' title="Average displacement (fundamental frequency) power factor from all phases daily (dPF)" :showLegend="false" yAxisTitle="dPF" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>


                <v-flex xs12 sm12 md12 class='pa-3 dense-flex'>
                  <h2>Frequency</h2>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphFreq' title="Frequency (Hz)" :showLegend="false" yAxisTitle="Frequency" :initialMin="0" :initialMax="100"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphFreq' title="Frequency hourly (Hz)" :showLegend="false" yAxisTitle="Frequency" :initialMin="0" :initialMax="100"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphFreq' title="Frequency daily (Hz)" :showLegend="false" yAxisTitle="Frequency" :initialMin="0" :initialMax="100"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md12 class='pa-3 dense-flex'>
                  <h2>Distortion</h2>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotThd' title="Total harmonic distortion from all phases (THD (%))" :showLegend="false" yAxisTitle="Percentage" :initialMin="0" :initialMax="100"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotThd' title="Total harmonic distortion from all phases hourly (THD (%))" :showLegend="false" yAxisTitle="Percentage" :initialMin="0" :initialMax="100"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotThd' title="Total harmonic distortion from all phases daily (THD (%))" :showLegend="false" yAxisTitle="Percentage" :initialMin="0" :initialMax="100"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md12 class='pa-3 dense-flex'>
                  <h2>Peak Demand</h2>
                </v-flex>
                <v-flex xs12 sm12 md6 class='pa-3' v-if='mode=="live"'>
                  <baseLiveGraph ref='graphTotPd' title="Total peak demands from all phases for the configured demand window (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseLiveGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> {{ totalLiveText }}</span></div>
                    <template v-if='line1Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l1Color}`'></div><span> Line 1</span></div></template>
                    <template v-if='line2Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l2Color}`'></div><span> Line 2</span></div></template>
                    <template v-if='line3Visible && lineVisibleCount > 1'><div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${l3Color}`'></div><span> Line 3</span></div></template>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="hourly"'>
                  <baseHistoryGraph ref='hourlyGraphTotPd' title="Total peak demands from all phases for the configured demand window for the configured demand window hourly (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12 class='pa-3' v-if='mode=="daily"'>
                  <baseHistoryGraph ref='dailyGraphTotPd' title="Total peak demands from all phases for the configured demand window for the configured demand window daily (kW)" :showLegend="false" yAxisTitle="kW" :initialMin="0" :initialMax="1"></baseHistoryGraph>
                  <div style="text-align:center;font-size:12px;color:#666666;">
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColor}`'></div><span> Total of timespan</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorIncomplete}`'></div><span> Total of timespan but data is incomplete</span></div>
                    <div style="display:inline-block;padding-left:8px;padding-right:8px;"><div :style='`display:inline-block;width:13px;height:13px;border:1px solid #333333;background-color:${totalColorMissing}`'></div><span> Total of timespan is missing</span></div>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model='updateDialog' persistent max-width='450px'>
        <v-card class="mx-auto">
          <v-card-title class='headline font-weight-regular oem-color'>
            Loading Data
          </v-card-title>
          <v-card-text>
            <span class='oem-text-color'>
              <div class="d-flex ma-3">
                {{ updateText }}
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <hollow-dots-spinner
                  :animation-duration="1000"
                  :dot-size="15"
                  :dots-num="3"
                  color= "var(--primary-color)"
                  class="pl-5"
                ></hollow-dots-spinner>
              </div>
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';
import ajax from '../ajax';
import baseLiveGraph from './BaseLiveGraph.vue';
import baseHistoryGraph from './BaseHistoryGraph.vue';

export default {
  name: 'Trends',

  components: {
    baseLiveGraph,
    baseHistoryGraph,
    HollowDotsSpinner,
  },

  data() {
    return {
      storeState: this.$store.state,
      selection: -1, // The selected load or pulseinput
      mode: 'live', // live, hourly or daily

      hourlySelectStart: null,
      hourlySelectEnd: null,
      dailySelectStart: null,
      dailySelectEnd: null,
      loadingTrendData: false,
      line1Visible: true,
      line2Visible: true,
      line3Visible: true,
      lineVisibleCount: 3,
      totalLiveText: 'Total',

      totalColor: 'rgba(29, 66, 138, 1)',
      totalColorIncomplete: 'rgba(97, 123, 173, 1)',
      totalColorMissing: 'rgba(141, 160, 196, 1)',

      l1Color: 'rgba(137, 30, 121, 1)',
      l2Color: 'rgba(137, 100, 30, 1)',
      l3Color: 'rgba(30, 137, 46, 1)',
      updateDialog: false,
      updateText: '',
    };
  },

  watch: {
    selection: {
      immediate: false,
      handler(_val, _oldVal) { // eslint-disable-line no-unused-vars
        // this.initializeGraphs();
        this.$nextTick(() => { // For some reason this is needed or the this.$refs properties are undefined
          this.initializeGraphs();
        });
      },
    },
    mode: {
      immediate: false,
      // this.initializeGraphs();
      handler(_val, _oldVal) { // eslint-disable-line no-unused-vars
        this.$nextTick(() => { // For some reason this is needed or the this.$refs properties are undefined
          this.initializeGraphs();
        });
      },
    },
  },

  methods: {
    initializeGraphs() {
      if (!(this.selection >= 0)) {
        return;
      }

      this.line1Visible = this.storeState.data.loads[this.selection].cts[0].active;
      this.line2Visible = this.storeState.data.loads[this.selection].cts[1].active;
      this.line3Visible = this.storeState.data.loads[this.selection].cts[2].active;
      this.lineVisibleCount = 0;
      if (this.line1Visible) this.lineVisibleCount++;
      if (this.line2Visible) this.lineVisibleCount++;
      if (this.line3Visible) this.lineVisibleCount++;
      if (this.line1Visible && !this.line2Visible && !this.line3Visible) {
        this.totalLiveText = 'Total (Line 1)';
      } else if (!this.line1Visible && this.line2Visible && !this.line3Visible) {
        this.totalLiveText = 'Total (Line 2)';
      } else if (!this.line1Visible && !this.line2Visible && this.line3Visible) {
        this.totalLiveText = 'Total (Line 3)';
      } else {
        this.totalLiveText = 'Total';
      }

      if (this.mode === 'live') {
        let config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_wh_out', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'wh_out', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'wh_out', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'wh_out', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotWh.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_wh_in', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'wh_in', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'wh_in', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'wh_in', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotWhDis.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_vah_out', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'vah_out', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'vah_out', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'vah_out', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotVah.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_vah_in', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'vah_in', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'vah_in', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'vah_in', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotVahDis.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_varh_cap_gen', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'varh_cap_gen', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'varh_cap_gen', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'varh_cap_gen', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotCVarh.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_varh_ind_gen', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'varh_ind_gen', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'varh_ind_gen', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'varh_ind_gen', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotIVarh.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_varh_cap_dis', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'varh_cap_dis', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'varh_cap_dis', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'varh_cap_dis', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotCVarhDis.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_varh_ind_dis', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'varh_ind_dis', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'varh_ind_dis', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'varh_ind_dis', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotIVarhDis.config(config);

        config = [];
        if (this.line1Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 0], value: 'v', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 1], value: 'v', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 2], value: 'v', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphV.config(config);

        config = [];
        if (this.line1Visible && this.line2Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 0], value: 'v_ll', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible && this.line3Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 1], value: 'v_ll', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible && this.line1Visible) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp', 'lines', 2], value: 'v_ll', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphVll.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_p', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'p', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'p', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'p', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotP.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_a', resolution: null, color: this.totalColor, factor: 1,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'a', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'a', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'a', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphA.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_s', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 's', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 's', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 's', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotS.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_q', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'q', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'q', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'q', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotQ.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_apf', resolution: null, color: this.totalColor, factor: 1,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'apf', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'apf', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'apf', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphTotApf.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_dpf', resolution: null, color: this.totalColor, factor: 1,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'dpf', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'dpf', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'dpf', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphTotDpf.config(config);

        this.$refs.graphFreq.config([{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: ['inp'], value: 'freq', resolution: null, color: this.totalColor, factor: 1,
        }]);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_thd', resolution: null, color: this.totalColor, factor: 1,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'thd', resolution: null, color: this.l1Color, factor: 1,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'thd', resolution: null, color: this.l2Color, factor: 1,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'thd', resolution: null, color: this.l3Color, factor: 1,
          });
        }
        this.$refs.graphTotThd.config(config);

        config = [{
          dataUrl: `data/load/${this.selection}`, externalData: true, item: [], value: 'tot_pd', resolution: null, color: this.totalColor, factor: 0.001,
        }];
        if (this.line1Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 0], value: 'pd', resolution: null, color: this.l1Color, factor: 0.001,
          });
        }
        if (this.line2Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 1], value: 'pd', resolution: null, color: this.l2Color, factor: 0.001,
          });
        }
        if (this.line3Visible && this.lineVisibleCount > 1) {
          config.push({
            dataUrl: `data/load/${this.selection}`, externalData: true, item: ['cts', 2], value: 'pd', resolution: null, color: this.l3Color, factor: 0.001,
          });
        }
        this.$refs.graphTotPd.config(config);
        this.updateFull();
      } else if (this.mode === 'hourly') {
        this.loadingTrendData = true;
        this.updateText = 'Please wait...';
        this.updateDialog = true;
        ajax.get('system/time')
          .then((response) => {
            const now = new Date(0);
            now.setUTCSeconds(response.data.time);

            const hoursToSelect = 168;
            this.hourlySelectEnd = new Date(now.getTime());
            this.hourlySelectEnd.setSeconds(0);
            this.hourlySelectEnd.setMinutes(0);
            this.hourlySelectStart = new Date(this.hourlySelectEnd.getTime());
            this.hourlySelectStart.setHours(this.hourlySelectStart.getHours() - hoursToSelect);

            this.$refs.hourlyGraphTotWh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_wh_out'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotWhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_wh_in'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotVah.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_vah_out'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotVahDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_vah_in'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotCVarh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_cap_gen'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotIVarh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_ind_gen'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotCVarhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_cap_dis'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotIVarhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_ind_dis'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphV.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['v_max'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphVll.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['v_ll_max'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphTotP.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_p'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphA.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_a'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphTotS.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_s'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotQ.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_q'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.hourlyGraphTotApf.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_apf'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphTotDpf.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_dpf'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphFreq.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['freq'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphTotThd.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_thd'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.hourlyGraphTotPd.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_pd'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 3600,
              xAxisMaxTime: this.hourlySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatHour,
              itemDataComplete: this.timeRangeHourCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);

            this.updateFull();
          })
          .catch((e) => {
            console.log(e); // eslint-disable-line no-console
          });
      } else if (this.mode === 'daily') {
        this.loadingTrendData = true;
        this.updateText = 'Please wait...';
        this.updateDialog = true;
        ajax.get('system/time')
          .then((response) => {
            const now = new Date(0);
            now.setUTCSeconds(response.data.time);

            const daysToSelect = 60;
            this.dailySelectEnd = new Date(now.getTime());
            this.dailySelectEnd.setSeconds(0);
            this.dailySelectEnd.setMinutes(0);
            this.dailySelectEnd.setHours(0);
            this.dailySelectStart = new Date(this.dailySelectEnd.getTime());
            this.dailySelectStart.setDate(this.dailySelectStart.getDate() - daysToSelect);

            this.$refs.dailyGraphTotWh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_wh_out'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotWhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_wh_in'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotVah.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_vah_out'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotVahDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_vah_in'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotCVarh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_cap_gen'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotIVarh.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_ind_gen'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotCVarhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_cap_dis'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotIVarhDis.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_varh_ind_dis'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphV.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['v_max'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphVll.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['v_ll_max'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphTotP.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_p'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphA.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_a'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphTotS.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_s'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotQ.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_q'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);
            this.$refs.dailyGraphTotApf.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_apf'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphTotDpf.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_dpf'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphFreq.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['freq'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphTotThd.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_thd'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 1,
            }]);
            this.$refs.dailyGraphTotPd.config([{
              dataUrl: `data/load/${this.selection}/trends`,
              postData: {
                start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
              },
              externalData: true,
              array: ['data'],
              item: [],
              value: ['tot_pd'],
              xAxisItem: [],
              xAxisValueFrom: 'ts_from',
              xAxisValueTo: 'ts_to',
              xAxisValueRange: 86400,
              xAxisMaxTime: this.dailySelectEnd.getTime() / 1000,
              xAxisFormatFunction: this.timeRangeFormatDay,
              itemDataComplete: this.timeRangeDayCorrect,
              resolution: null,
              color: this.totalColor,
              incompleteDataColor: this.totalColorIncomplete,
              missingDataColor: this.totalColorMissing,
              factor: 0.001,
            }]);

            this.updateFull();
          })
          .catch((e) => {
            console.log(e); // eslint-disable-line no-console
          });
      }
    },


    timeRangeFormatHour(timeEpochFrom, timeEpochTo, _expectedTimeRange, _data) { // eslint-disable-line no-unused-vars
      const dateTimeTo = new Date(timeEpochTo * 1000);
      let dateTimeFrom = new Date(timeEpochFrom * 1000);

      // round the time up towards nearest hour
      if (dateTimeTo.getSeconds() !== 0) {
        dateTimeTo.setMinutes(dateTimeTo.getMinutes() + 1);
        dateTimeTo.setSeconds(0);
      }
      if (dateTimeTo.getMinutes() !== 0) {
        dateTimeTo.setHours(dateTimeTo.getHours() + 1);
        dateTimeTo.setMinutes(0);
      }

      /*
      // round the time up towards nearest hour
      if (dateTimeFrom.getSeconds() !== 0) {
        dateTimeFrom.setMinutes(dateTimeFrom.getMinutes() + 1);
        dateTimeFrom.setSeconds(0);
      }
      if (dateTimeFrom.getMinutes() !== 0) {
        dateTimeFrom.setHours(dateTimeFrom.getHours() + 1);
        dateTimeFrom.setMinutes(0);
      }
      */
      dateTimeFrom = new Date(dateTimeTo.getTime());
      dateTimeFrom.setHours(dateTimeFrom.getHours() - 1);


      // Format the string
      const date = `${dateTimeFrom.getFullYear()}-${(`0${dateTimeFrom.getMonth() + 1}`).substr(-2)}-${(`0${dateTimeFrom.getDate()}`).substr(-2)}`;
      const timeFrom = `${(`0${dateTimeFrom.getHours()}`).substr(-2)}:${(`0${dateTimeFrom.getMinutes()}`).substr(-2)}`;
      const timeTo = `${(`0${dateTimeTo.getHours()}`).substr(-2)}:${(`0${dateTimeTo.getMinutes()}`).substr(-2)}`;

      return `${date} ${timeFrom}-${timeTo}`;
    },
    timeRangeHourCorrect(timeEpochFrom, timeEpochTo, expectedTimeRange) {
      return Math.abs(expectedTimeRange - (timeEpochTo - timeEpochFrom)) <= 10; // 10 to account for rounding errors. The value 1 should be enough, but we're keeping a small margin
    },

    timeRangeFormatDay(timeEpochFrom, timeEpochTo, _expectedTimeRange, _data) { // eslint-disable-line no-unused-vars
      const dateTimeTo = new Date(timeEpochTo * 1000);
      let dateTimeFrom = new Date(timeEpochFrom * 1000);

      // round the time up towards nearest day
      if (dateTimeTo.getSeconds() !== 0) {
        dateTimeTo.setMinutes(dateTimeTo.getMinutes() + 1);
        dateTimeTo.setSeconds(0);
      }
      if (dateTimeTo.getMinutes() !== 0) {
        dateTimeTo.setHours(dateTimeTo.getHours() + 1);
        dateTimeTo.setMinutes(0);
      }
      if (dateTimeTo.getHours() !== 0) {
        dateTimeTo.setDate(dateTimeTo.getDate() + 1);
        dateTimeTo.getHours(0);
      }

      /*
      // round the time up towards nearest day
      if (dateTimeFrom.getSeconds() !== 0) {
        dateTimeFrom.setMinutes(dateTimeFrom.getMinutes() + 1);
        dateTimeFrom.setSeconds(0);
      }
      if (dateTimeFrom.getMinutes() !== 0) {
        dateTimeFrom.setHours(dateTimeFrom.getHours() + 1);
        dateTimeFrom.setMinutes(0);
      }
      if (dateTimeFrom.getHours() !== 0) {
        dateTimeFrom.setDate(dateTimeFrom.getDate() + 1);
        dateTimeFrom.setHours(0);
      }
      */

      dateTimeFrom = new Date(dateTimeTo.getTime());
      dateTimeFrom.setDate(dateTimeFrom.getDate() - 1);

      // Format the string
      const date = `${dateTimeFrom.getFullYear()}-${(`0${dateTimeFrom.getMonth() + 1}`).substr(-2)}-${(`0${dateTimeFrom.getDate()}`).substr(-2)}`;

      return date;
    },
    timeRangeDayCorrect(timeEpochFrom, timeEpochTo, expectedTimeRange) {
      return Math.abs(expectedTimeRange - (timeEpochTo - timeEpochFrom)) <= 10; // 10 to account for rounding errors. The value 1 should be enough, but we're keeping a small margin
    },

    updateFull() {
      if (this.selection !== -1) {
        this.updateOncePerSecond();
        this.updateOnce();
      }
    },
    updateOncePerSecond() {
      if (this.selection !== -1) {
        if (this.mode === 'live') {
          const { selection } = this;
          ajax.get(`data/load/${selection}`)
            .then((response) => {
              if (this.mode === 'live') {
                const data = {};
                data[`data/load/${selection}`] = response.data;
                this.$refs.graphTotWh.processData(data);
                this.$refs.graphTotWhDis.processData(data);
                this.$refs.graphTotVah.processData(data);
                this.$refs.graphTotVahDis.processData(data);
                this.$refs.graphTotCVarh.processData(data);
                this.$refs.graphTotIVarh.processData(data);
                this.$refs.graphTotCVarhDis.processData(data);
                this.$refs.graphTotIVarhDis.processData(data);
                this.$refs.graphV.processData(data);
                this.$refs.graphVll.processData(data);
                this.$refs.graphTotP.processData(data);
                this.$refs.graphA.processData(data);
                this.$refs.graphTotS.processData(data);
                this.$refs.graphTotQ.processData(data);
                this.$refs.graphTotApf.processData(data);
                this.$refs.graphTotDpf.processData(data);
                this.$refs.graphFreq.processData(data);
                this.$refs.graphTotThd.processData(data);
                this.$refs.graphTotPd.processData(data);
              }
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
            });
        }
      }
    },
    updateOnce() {
      if (this.selection !== -1) {
        if (this.mode === 'hourly') {
          const postData = {
            start: this.hourlySelectStart.getTime() / 1000, end: this.hourlySelectEnd.getTime() / 1000, format: 'json', merge: 3600,
          };
          const { selection } = this;
          ajax.post(`data/load/${selection}/trends`, postData)
            .then((response) => {
              if (this.mode === 'hourly') {
                const data = {};
                data[`data/load/${selection}/trends|${JSON.stringify(postData)}`] = response.data;
                this.$refs.hourlyGraphTotWh.processData(data);
                this.$refs.hourlyGraphTotWhDis.processData(data);
                this.$refs.hourlyGraphTotVah.processData(data);
                this.$refs.hourlyGraphTotVahDis.processData(data);
                this.$refs.hourlyGraphTotCVarh.processData(data);
                this.$refs.hourlyGraphTotIVarh.processData(data);
                this.$refs.hourlyGraphTotCVarhDis.processData(data);
                this.$refs.hourlyGraphTotIVarhDis.processData(data);
                this.$refs.hourlyGraphV.processData(data);
                this.$refs.hourlyGraphVll.processData(data);
                this.$refs.hourlyGraphTotP.processData(data);
                this.$refs.hourlyGraphA.processData(data);
                this.$refs.hourlyGraphTotS.processData(data);
                this.$refs.hourlyGraphTotQ.processData(data);
                this.$refs.hourlyGraphTotApf.processData(data);
                this.$refs.hourlyGraphTotDpf.processData(data);
                this.$refs.hourlyGraphFreq.processData(data);
                this.$refs.hourlyGraphTotThd.processData(data);
                this.$refs.hourlyGraphTotPd.processData(data);
                this.loadingTrendData = false;
                this.updateDialog = false;
                this.updateText = '';
              }
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
            });
        } else if (this.mode === 'daily') {
          const postData = {
            start: this.dailySelectStart.getTime() / 1000, end: this.dailySelectEnd.getTime() / 1000, format: 'json', merge: 86400,
          };
          const { selection } = this;
          ajax.post(`data/load/${selection}/trends`, postData)
            .then((response) => {
              if (this.mode === 'daily') {
                const data = {};
                data[`data/load/${selection}/trends|${JSON.stringify(postData)}`] = response.data;
                this.$refs.dailyGraphTotWh.processData(data);
                this.$refs.dailyGraphTotWhDis.processData(data);
                this.$refs.dailyGraphTotVah.processData(data);
                this.$refs.dailyGraphTotVahDis.processData(data);
                this.$refs.dailyGraphTotCVarh.processData(data);
                this.$refs.dailyGraphTotIVarh.processData(data);
                this.$refs.dailyGraphTotCVarhDis.processData(data);
                this.$refs.dailyGraphTotIVarhDis.processData(data);
                this.$refs.dailyGraphV.processData(data);
                this.$refs.dailyGraphVll.processData(data);
                this.$refs.dailyGraphTotP.processData(data);
                this.$refs.dailyGraphA.processData(data);
                this.$refs.dailyGraphTotS.processData(data);
                this.$refs.dailyGraphTotQ.processData(data);
                this.$refs.dailyGraphTotApf.processData(data);
                this.$refs.dailyGraphTotDpf.processData(data);
                this.$refs.dailyGraphFreq.processData(data);
                this.$refs.dailyGraphTotThd.processData(data);
                this.$refs.dailyGraphTotPd.processData(data);
                this.loadingTrendData = false;
                this.updateDialog = false;
                this.updateText = '';
              }
            })
            .catch((e) => {
              console.log(e); // eslint-disable-line no-console
            });
        }
      }
    },
  },

  timers: {
    updateOncePerSecond: { time: 1000, repeat: true, autostart: true },
    // updateOncePerFiveMinutes: { time: 300000, repeat: true, autostart: true },
  },

  mounted() {
    this.initializeGraphs();
  },
};
</script>

<style>
  .v-list.dense-list {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-list.dense-list>div>div {
    padding-left: 0px;
    padding-right: 0px;
    height: 28px;
  }
  .dense-flex {
    padding-top: 0px !important;
    padding-bottom: 4px !important;
    padding-right: 0px !important;
    padding-left: 14px !important;
  }
  .flex.lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
</style>
